export default __webpack_public_path__ + "static/media/SetupIcon.6e98e997.svg";